import { useState } from "react";
import { C } from "../../shared/theme";
import { findTheory, strategiesFor, reasonsFor, talkMessage, KIND } from "./theories";
import { WRITEUPS } from "./writeups";
import { kindHue, sectionLabel, pageTitle, body, card, resetButton, primaryButton } from "./learnStyles";
import { TheoryRow } from "./TheoryList";

// One reason or strategy: summary, plain explanation, the other side of the
// cross-reference, a way into Chat, and the sources behind it.
export function TheoryDetail({ kind, n, onOpen, onTalk }) {
  const [showResearch, setShowResearch] = useState(false);
  const theory = findTheory(kind, n);
  if (!theory) return <p style={{ ...body, padding: "4px 20px", color: C.textMid }}>We couldn't find that page.</p>;

  const isReason = kind === KIND.PROBLEM;
  const writeup = WRITEUPS[`${kind}${n}`];
  const links = isReason ? strategiesFor(n) : reasonsFor(n);
  const linkKind = isReason ? KIND.SOLUTION : KIND.PROBLEM;
  const research = writeup?.research || [];

  return (
    <div style={{ padding: "4px 20px 28px", display: "flex", flexDirection: "column", gap: 12 }}>
      <div style={sectionLabel(kindHue(kind).c)}>{isReason ? "Why we put things off" : "Conquer procrastination"} · {n}</div>
      <h1 tabIndex={-1} style={{ ...pageTitle, color: C.text, outline: "none" }}>{theory.title}</h1>
      <p style={{ margin: 0, fontSize: 17, lineHeight: 1.5, color: C.textMid }}>{theory.summary}</p>

      {writeup && (
        <>
          <h2 style={{ ...sectionLabel(C.textMid), margin: "8px 0 0" }}>{isReason ? "What's going on" : "Why it works"}</h2>
          {writeup.paras.map((p, i) => <p key={i} style={{ ...body, color: C.text }}>{p}</p>)}
        </>
      )}

      {links.length > 0 && (
        <>
          <h2 style={{ ...sectionLabel(C.textMid), margin: "8px 0 0" }}>{isReason ? "What helps" : "It helps with"}</h2>
          <div style={card()}>
            {links.map(t => <TheoryRow key={t.n} kind={linkKind} theory={t} onOpen={onOpen} compact />)}
          </div>
        </>
      )}

      <button onClick={() => onTalk(talkMessage(kind, theory))} style={{ ...primaryButton(), marginTop: 6 }}>
        Talk it through in Chat
      </button>

      {research.length > 0 && (
        <>
          <button onClick={() => setShowResearch(s => !s)} aria-expanded={showResearch}
            style={{ ...resetButton, minHeight: 44, display: "flex", alignItems: "center", justifyContent: "space-between", padding: "0 4px", borderTop: `1px solid ${C.border}`, color: C.textMid, fontSize: 14, fontWeight: 700, marginTop: 6 }}>
            <span>The research behind this</span><span aria-hidden="true">{showResearch ? "▲" : "▼"}</span>
          </button>
          {showResearch && (
            <ul style={{ margin: 0, padding: 0, listStyle: "none", display: "flex", flexDirection: "column", gap: 8 }}>
              {research.map(r => <li key={r} style={{ fontSize: 14, lineHeight: 1.5, color: C.textMid, paddingLeft: 12, borderLeft: `2px solid ${C.border}` }}>{r}</li>)}
            </ul>
          )}
        </>
      )}
    </div>
  );
}
